import { makeStore } from '../customStore';
export const resource = makeStore({
    thoughts: 0,
    cheese: 0,
    moldyCheese: 0,
    cheeseMonster: 0,
    cheeseBrains: 0,
    milk: 0,
    milkPower: 0,
    milkPoints: 0,
});
